import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { environment } from "../../../environments/environment";

/**
 * Guard class for prod
 */
@Injectable()
export class ProdGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (environment.production) {
            // logged in so return true
            this.router.navigate(['/auth']);
            return false;
        }

        return true;
    }
}
